import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { withStyles } from 'tss-react/mui';
import { ListBox, ListBoxProps } from './ListBox.component';
import { ListContainedContainer } from './ListContainedContainer.component';
import { SelectionOverview, SelectionOverviewProps } from './SelectionOverview.component';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { grey } from '@mui/material/colors';
import { useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';

export type SelectListsContainedProps = {
  lists: (ListBoxProps & { label: string })[];
  label?: string;
  helperText?: string;
  error?: boolean;
} & Omit<SelectionOverviewProps, 'selectedCount'>;

const Accordion = withStyles(MuiAccordion, (theme, _params, classes) => ({
  root: {
    boxShadow: 'none',
    '&:not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.divider} !important`,
    },
    '& > .summary': {
      '&.Mui-expanded': {
        borderBottom: `1px solid ${theme.palette.divider} !important`,
      }
    },
    '&:before': {
      display: 'none',
    },
    [`&.${classes.expanded}`]: {
      margin: 'auto',
    },
  },
  expanded: {},
}));

const AccordionSummary = withStyles(MuiAccordionSummary, (_theme, _params, classes) => ({
  root: {
    minHeight: 48,
    [`&.${classes.expanded}`]: {
      minHeight: 48,
    },
  },
  content: {
    [`&.${classes.expanded}`]: {
      margin: 0,
    },
    fontWeight: 600,
  },
  expanded: {},
}));

const AccordionDetails = withStyles(MuiAccordionDetails, {
  root: {
    padding: 0,
  },
});

export const SelectListsContained: React.VFC<SelectListsContainedProps> = props => {
  const { classes } = useSelectListsContainedStyles();
  const [ expanded, setExpanded ] = useState<number | false>(0);
  const formik = useFormikContext<Record<string, any>>();

  const names = props.lists.map(list => list.name);

  const selectedIds = names.reduce((acc: string[], name) => {
    if (Array.isArray(formik.values[name])) {
      return [ ...acc, ...formik.values[name] ];
    }

    return acc;
  }, []);

  return (
    <ListContainedContainer
      hasError={false}
      label={props.label}
      flex={false}
    >
      <Box className={classes.accordianContainer}>
        {props.lists.map(({ label, ...props }, index) => {

          return (
            <Accordion square key={index} expanded={expanded === index} onChange={() => setExpanded(isExpanded => (isExpanded === index ? false : index))}>
              <AccordionSummary className="summary" expandIcon={<ExpandMore />}>{label}</AccordionSummary>
              <AccordionDetails>
                <Box flex={1} height="260px" bgcolor={grey[100]}>
                  <ListBox {...props} disableListPadding />
                </Box>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
      <SelectionOverview
        selectedCount={selectedIds.length}
        selectionOverviewText={props.selectionOverviewText}
      />
    </ListContainedContainer>
  );
};

const useSelectListsContainedStyles = makeStyles({ name: 'SelectListsContained' })(theme => ({
  accordianContainer: {
    '& .MuiAccordion-root': {
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.divider}`
      }
    }
  },
}));